import { lazy } from "react";
import { Route } from "react-router-dom";
import { LazyRoute } from "./LazyRoute";

const ThemeManager = lazy(() => import("@/features/admin/pages/ThemeManager"));
const UserManager = lazy(() => import("@/features/admin/pages/UserManager"));
const StudentManager = lazy(() => import("@/features/admin/pages/StudentManager"));
const AdminStudentDetailPage = lazy(() => import("@/features/admin/pages/AdminStudentDetailPage"));
const ParentManager = lazy(() => import("@/features/admin/pages/ParentManager"));
const AdminParentDetailPage = lazy(() => import("@/features/admin/pages/AdminParentDetailPage"));
const JobManager = lazy(() => import("@/features/admin/pages/JobManager"));
const InvitesPage = lazy(() => import("@/features/admin/pages/InvitesPage"));
const AdminStoriesPage = lazy(() => import("@/features/admin/pages/AdminStoriesPage"));
const AdminStoryDetailPage = lazy(() => import("@/features/admin/pages/AdminStoryDetailPage"));

const adminFallback = "Loading admin panel...";

export const adminRoutes = (
  <>
    <Route
      path="/admin/themes"
      element={
        <LazyRoute fallbackMessage={adminFallback}>
          <ThemeManager />
        </LazyRoute>
      }
    />
    <Route
      path="/admin/users"
      element={
        <LazyRoute fallbackMessage={adminFallback}>
          <UserManager />
        </LazyRoute>
      }
    />
    <Route
      path="/admin/students"
      element={
        <LazyRoute fallbackMessage={adminFallback}>
          <StudentManager />
        </LazyRoute>
      }
    />
    <Route
      path="/admin/students/:id"
      element={
        <LazyRoute fallbackMessage={adminFallback}>
          <AdminStudentDetailPage />
        </LazyRoute>
      }
    />
    <Route
      path="/admin/parents"
      element={
        <LazyRoute fallbackMessage={adminFallback}>
          <ParentManager />
        </LazyRoute>
      }
    />
    <Route
      path="/admin/parents/:parentId"
      element={
        <LazyRoute fallbackMessage={adminFallback}>
          <AdminParentDetailPage />
        </LazyRoute>
      }
    />
    <Route
      path="/admin/jobs"
      element={
        <LazyRoute fallbackMessage={adminFallback}>
          <JobManager />
        </LazyRoute>
      }
    />
    <Route
      path="/admin/invites"
      element={
        <LazyRoute fallbackMessage={adminFallback}>
          <InvitesPage />
        </LazyRoute>
      }
    />
    <Route
      path="/admin/stories"
      element={
        <LazyRoute fallbackMessage={adminFallback}>
          <AdminStoriesPage />
        </LazyRoute>
      }
    />
    <Route
      path="/admin/stories/:id"
      element={
        <LazyRoute fallbackMessage={adminFallback}>
          <AdminStoryDetailPage />
        </LazyRoute>
      }
    />
  </>
);
